import React, {useContext, useEffect, useState} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import roleService from "../../../../../services/web/role-service.js";
import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";
import {RoleContext} from "../context/role-context.jsx";
import projectUtils from "../../../../../utils/project-utils.js";

const RoleModalNoc = ({open, setOpen, rowPermission, permissions}) => {
    const {maintenanceSelected, setMaintenanceSelected} = useContext(RoleContext);

    const [permissionNoc, setPermissionNoc] = useState(undefined);
    const [maintenanceSelectedComponent, setMaintenanceSelectedComponent] = useState(maintenanceSelected);

    const {data} = useQuery({
        queryFn: () => roleService.maintenanceGroups().then(data => ([{ value: 'all', label: 'Todos'}, ...data.data])),
        queryKey: ["groups"]
    });

    useEffect(() => {
        if (!permissions) return

        setPermissionNoc(permissions.find(p => p.name === PermissionEnum.CAPTURE_PLACE_NOC));
    }, [permissions]);

    useEffect(() => {
        if (open) setMaintenanceSelectedComponent(maintenanceSelected);
    }, [open, maintenanceSelected]);

    const cancel = () => {
        if (!maintenanceSelectedComponent) {
            rowPermission.node.setSelected(false);
        }

        setOpen(false);
    }

    const confirm = () => {
        if (!maintenanceSelectedComponent) {
            projectUtils.swalErrorMessage('', "Selecione um responsável por manutenção.", 'Ok');
            return;
        }

        setMaintenanceSelected(maintenanceSelectedComponent);
        setOpen(false);
    }

    return (
        <Modal open={open} setOpen={setOpen} title={"Permissão de visualização de câmeras e smartcaptures"} className={"w-8/12"} overflow={true} isCloseClick={false}>
            <Modal.Body className={"space-y-2"}>
                <SelectComponent
                    id="groups"
                    value={maintenanceSelectedComponent}
                    options={data ?? []}
                    label={"Responsável por manutenção"}
                    onChange={(value) => setMaintenanceSelectedComponent(value)}
                />

                <table>
                    <thead className={"bg-[#efefef] !text-[#2E3742] border border-[#dbdbdb] !text-[13px]"}>
                    <tr>
                        <th className={"p-2 border-r border-r-[#dbdbdb]"} style={{width: '20%'}}>Grupo</th>
                        <th className={"p-2"}>Permissão afetadas</th>
                    </tr>
                    </thead>
                    <tbody className={"border border-[#dbdbdb] border-t-0"}>
                    {
                        permissionNoc &&
                        <tr>
                            <td className={"p-2 border-r border-r-[#dbdbdb]"}>{permissionNoc.group}</td>
                            <td className={"p-2"}>
                                {permissionNoc.text}
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={confirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RoleModalNoc;
